import styled from 'styled-components'
import FantaTheme from '@chegg-wt/core/theme/fanta/theme'

export const BoldText = styled.div`
  font-size: ${FantaTheme.font.text.size.xlg};
  font-weight: ${FantaTheme.font.weight.bold};
`

export const FullWidthBanner = styled.div<{
  backgroundColour: string
  minHeight: string
}>`
  display: flex;
  flex-direction: column;
  background-color: ${({ backgroundColour }) => backgroundColour};
  justify-content: center;
  align-items: center;
  text-align: center;

  width: 100%;
  min-height: ${({ minHeight }) => minHeight || 'unset'};
  padding: ${FantaTheme.spacing.fanta.sm};

  font-size: ${FantaTheme.font.text.size.md};
  line-height: 1.25rem;
`
